import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'aria-local-loader',
    templateUrl: './local-loader.component.html',
    styleUrls: ['./local-loader.component.scss']
})
export class LocalLoaderComponent {

    @Input() inLoading: boolean;

    // LOADER
    @Input() loaderTemplate: TemplateRef<any>;

    constructor() {

    }

}
